import { render, staticRenderFns } from "./app-info-bar.vue?vue&type=template&id=2b5f4086&scoped=true&"
import script from "./app-info-bar.vue?vue&type=script&lang=js&"
export * from "./app-info-bar.vue?vue&type=script&lang=js&"
import style0 from "./app-info-bar.vue?vue&type=style&index=0&id=2b5f4086&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b5f4086",
  null
  
)

export default component.exports